import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';

const SITE_URL = 'https://superbuyspread.skin';

export default function Home() {
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'Superbuy Spreadsheet',
        url: SITE_URL,
        description: 'Discover the ultimate Superbuy Spreadsheet with thousands of verified fashion finds — shoes, hoodies, bags, accessories and more. Updated daily with trusted shopping guides, QC tips, and shipping resources for smart buyers worldwide.',
        publisher: {
          '@type': 'Organization',
          name: 'Superbuy Spreadsheet',
          url: SITE_URL,
        },
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://kaspreadsheet.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'Superbuy Spreadsheet',
        url: SITE_URL,
        description: 'The ultimate resource for verified fashion finds, shopping guides, and spreadsheet-based discovery across shoes, hoodies, bags, and accessories.',
        sameAs: [
          'https://kaspreadsheet.com',
        ],
      },
    ],
  };

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <Hero />

      <div id="category-dropdown">
        <CategoryDropdown />
      </div>

      <div id="category-grid">
        <CategoryGrid />
      </div>

      <SEOContent />

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-[700px] mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Ready to Upgrade Your Wardrobe?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-[500px] mx-auto">
            Join thousands of buyers using our Superbuy Spreadsheet daily. Browse 14 categories, discover
            verified finds, and shop with confidence.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all hover:-translate-y-0.5 cursor-pointer flex items-center justify-center gap-2"
            >
              Open kaspreadsheet.com
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full border border-foreground-200 text-foreground-700 text-base font-medium hover:bg-background-100 transition-all hover:-translate-y-0.5 cursor-pointer flex items-center justify-center gap-2"
            >
              superbuy sheet
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}